import { compareFileNames } from '@tanko/shared'

/**
 * 集合頁的顯示順序。`position` 是集合儲存的自訂順序（資料），標題順逆排只是看的方式
 * （偏好）——切換不寫回雲端、不動 position。只有 position 下可以拖曳。
 */
export const collectionSortOrders = ['position', 'title-asc', 'title-desc'] as const
export type CollectionSortOrder = typeof collectionSortOrders[number]
export const DEFAULT_COLLECTION_SORT: CollectionSortOrder = 'position'

export function isCollectionSortOrder(value: unknown): value is CollectionSortOrder {
  return typeof value === 'string' && (collectionSortOrders as readonly string[]).includes(value)
}

/** 依顯示順序排列成員；`position` 維持輸入順序（輸入本來就依 position 排好）。回傳新陣列。 */
export function sortMembers<T extends { title: string }>(members: readonly T[], order: CollectionSortOrder): T[] {
  if (order === 'position') return [...members]
  const direction = order === 'title-asc' ? 1 : -1
  return [...members].sort((a, b) => compareFileNames(a.title, b.title) * direction)
}
